module.exports = __webpack_public_path__ + "static/media/logo_1_white.b6e91cd1.png";